import { createFileRoute } from '@tanstack/react-router'
import UmbrellaHomeV3 from '@/components/umbrella/UmbrellaHomeV3'

export const Route = createFileRoute('/home-v3')({
  component: UmbrellaHomeV3,
})
